import React, { Component } from 'react';
import widgets from '../../../data/infowidgets.json';
import { Link } from 'react-router-dom';

class Infowidgets extends Component {
    render() {
        return (
            <section className="banner-bottom">
                <div className="container">
                    <div className="row no-gutters justify-content-center">
                        {/* Data */}
                        {widgets.slice(0, 3).map((item, i) => (
                            <div className="col-lg-4 col-md-6" key={i}>
                                <div className={"box-" + item.id}>
                                    <h4 className="text-custom-white">{item.title}</h4>
                                    <p>{item.text}</p>
                                    <Link to="/jobs-grid" className=" btn-small btn-second">View More</Link>
                                </div>
                            </div>
                        ))}
                        {/* Data */}
                    </div>
                </div>
            </section>

        );
    }
}

export default Infowidgets;